<div id="page-login"
    class="site-wrapper">
    <main class="main">
        <div class="page-wrapper">
            <div class="page-content lean">
                <a routerLink="/">
                    <img class="logo"
                        src="/assets/images/logo/logo-teamworks-primary_white.svg"
                        alt="" />
                </a>

                <form [formGroup]="loginForm"
                    class="login-form"
                    (ngSubmit)="onSubmit()">
                    <mat-form-field class="minimal">
                        <mat-label>{{'LOGIN.EMAIL_PLACEHOLDER' | translate}}</mat-label>
                        <input matInput
                            type="email"
                            formControlName="username"
                            name="username"
                            spellcheck="false"
                            required
                            [attr.data-cy]="dataCySelectors.USERNAME_INPUT">
                        <mat-error *ngIf="loginForm.controls.username.hasError('required')"
                            [innerHTML]="'LOGIN.EMAIL_REQUIRED' | translate">
                        </mat-error>
                        <mat-error *ngIf="loginForm.controls.username.hasError('email')"
                            [innerHTML]="'LOGIN.EMAIL_ERROR' | translate">
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field class="minimal">
                        <mat-label>{{ 'LOGIN.PASSWORD_PLACEHOLDER' | translate}}</mat-label>
                        <input matInput
                            type="password"
                            formControlName="password"
                            [attr.data-cy]="dataCySelectors.PASSWORD_INPUT"
                            required>
                        <mat-error *ngIf="loginForm.controls.password.hasError('required')"
                            [innerHTML]="'LOGIN.PASSWORD_REQUIRED' | translate">
                        </mat-error>
                    </mat-form-field>

                    <button type="submit"
                        class="btn-login oa-button"
                        [class.loading]="submitDisabled$ | async"
                        [disabled]="submitDisabled$ | async"
                        [attr.data-cy]="dataCySelectors.LOGIN_SUBMIT_BUTTON">{{ 'LOGIN.LOGIN_BUTTON' | translate }}</button>
                </form>

                <div class="error-container">
                    <p class="form-message {{(authStatusMessage$ | async)?.type === 'success' ? 'form-success' : 'form-error'}}"
                        [class.expanded]="!!(authStatusMessage$ | async)?.message">
                        {{(authStatusMessage$ | async)?.message}}
                    </p>

                    <div class="forgot-password">
                        {{ 'LOGIN.FORGOT_PASSWORD' | translate }} <a class="forgot-password__link"
                            [attr.data-cy]="dataCySelectors.FORGOT_PASSWORD_LINK"
                            [routerLink]="['/forgot-password']">{{ 'LOGIN.FORGOT_PASSWORD_CLICK_HERE' | translate }}.</a>
                    </div>
                </div>
            </div>
        </div>
    </main>
</div>
